import * as React from 'react';
import { Route } from 'react-router';
import AuthRoute from './components/AuthRoute';
import Pages from './components/pages';

import './css/custom.css'
import './css/hcs_design_system.css'

export default () => (
  <>
    <AuthRoute exact path='/' component={Pages.Profile} />
    <AuthRoute exact path='/profile' component={Pages.Profile} />
    <AuthRoute exact path='/documents' component={Pages.Documents} />
    <Route path="/loggedOut" component={Pages.LoggedOut} />
    <Route path="/logout" component={Pages.Logout} />
    <Route path="/remotelogout" component={Pages.RemoteLogout} />
    <Route path="/signin-oidc" component={Pages.OidcCallback} />
  </>
);
